import { CHAIN_IDS } from '@/constants/chains';
import { ReactComponent as Avax } from '@/assets/icons/avax.svg';
import { ReactComponent as Arb } from '@/assets/icons/arb.svg';
import { ReactComponent as Eth } from '@/assets/icons/eth.svg';

export const typeToIcon: AnyLiteral = {
  [CHAIN_IDS.AVAX]: Avax,
  [CHAIN_IDS.ARBITRUM]: Arb,
  [CHAIN_IDS.ETH]: Eth
};

export const chainName = {
  [CHAIN_IDS.AVAX]: 'Avalanche',
  [CHAIN_IDS.ARBITRUM]: 'Arbitrum',
  [CHAIN_IDS.ETH]: 'Ethereum'
};

export type ChainType = ValuesOf<typeof CHAIN_IDS>;
export { CHAIN_IDS };
